(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-store-trial"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-store-trial]').forEach(card => {
  const choices = card.querySelector('[data-trial-choices]');
  const result = card.querySelector('[data-trial-result]');
  const stores = {
    calgary: { name: 'Calgary showroom', trackingName: 'Calgary', address: '6624 Centre St S, Calgary, AB', phone: '(403) 455-4466', tel: '14034554466', map: 'https://maps.app.goo.gl/vW2HBCGTjUoeekcd9' },
    edmonton: { name: 'Edmonton showroom', trackingName: 'Edmonton', address: '5111 99th St, Edmonton, AB', phone: '(780) 455-4466', tel: '17804554466', map: 'https://maps.app.goo.gl/WpTxuAy8RXootrtcA' }
  };
  card.querySelector('[data-trial-open]')?.addEventListener('click', event => { choices.hidden = false; event.currentTarget.hidden = true; });
  choices?.addEventListener('click', event => {
    const button = event.target.closest('[data-trial-store]');
    if (!button) return;
    choices.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    const store = stores[button.dataset.trialStore];
    result.innerHTML = `<div class="trial-location"><span class="trial-location__icon">●</span><div><h3>${store.name}</h3><p>${store.address}<br>${store.phone}</p></div><div class="trial-location__actions"><a class="trial-location__directions" href="${store.map}" target="_blank" rel="noopener" onclick="trackButtonClick('Get Directions')">Get directions <span>↗</span></a><a class="trial-location__call" href="tel:${store.tel}" onclick="trackButtonClick('Call ${store.trackingName}')"><span>☎</span> Call store</a></div></div>`;
    result.hidden = false;
    card.closest('.product-media')?.classList.add('product-media--trial-expanded');
    requestAnimationFrame(() => result.scrollIntoView({ behavior: 'smooth', block: 'nearest' }));
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sleep-quiz-attribution"] && !Shopify.designMode) return;
  try {
    if (!window.CMSleepQuizTracking) {
  const version = 'comfort_v2';
  const key = 'cm_sleep_quiz_product';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function googleCommand() { window.dataLayer.push(arguments); }
  const track = (event, parameters = {}) => {
    if (!allowed() || window.Shopify?.designMode) return;
    const data = { quiz_id: 'mattress_match', quiz_version: version, ...parameters };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
    googleCommand('event', `cm_${event}`, { ...data, send_to: 'G-NQN7NC5JQT', event_callback: () => { document.documentElement.dataset.sleepQuizAnalyticsProcessed = event; }, event_timeout: 2000 });
    try { window.Shopify?.analytics?.publish?.(`cm:${event}`, data); } catch (error) {}
  };
  window.CMSleepQuizTracking = { track };
  const query = new URLSearchParams(location.search);
  const productPath = /\/products\/[^/]+\/?$/.test(location.pathname);
  let viewed = false;
  const loadAttribution = () => {
    try {
      if (!allowed()) { sessionStorage.removeItem(key); return null; }
      if (productPath && query.get('sq') === version && /^\d+$/.test(query.get('variant') || '') && ['1','2'].includes(query.get('sq_rank'))) {
        const value = { version, path: location.pathname, variant: query.get('variant'), rank: Number(query.get('sq_rank')), expires: Date.now()+1800000 };
        sessionStorage.setItem(key, JSON.stringify(value));
        return value;
      }
      const value = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!value || value.version !== version || value.expires < Date.now() || !/^\d+$/.test(value.variant)) return null;
      return value;
    } catch (error) { return null; }
  };
  const attach = () => {
    const requestedProduct = query.get('sleep_match_product');
    const requestedVariant = query.get('sleep_match_variant');
    const message = document.querySelector('form textarea[id$="-body"]');
    const enquiry = document.querySelector('[data-sleep-quiz-contact-copy]')?.dataset.sleepQuizContactCopy;
    if (enquiry && message && !message.value.trim() && requestedProduct && requestedProduct.length <= 200 && /^\d+$/.test(requestedVariant || '')) message.value = enquiry.replace('[product]', requestedProduct).replace('[variant]', requestedVariant);
    const banner = document.querySelector('[data-sleep-quiz-enquiry-banner]');
    if (banner && enquiry && location.pathname.endsWith('/pages/contact') && requestedProduct && requestedProduct.length <= 200 && /^\d+$/.test(requestedVariant || '')) {
      const heading = banner.querySelector('[data-enquiry-heading]');
      heading.textContent = heading.dataset.copy.replace('[product]', requestedProduct);
      banner.querySelectorAll('[data-enquiry-email]').forEach(link => { link.href = `mailto:${link.dataset.enquiryEmail}?subject=${encodeURIComponent(heading.textContent)}&body=${encodeURIComponent(enquiry.replace('[product]',requestedProduct).replace('[variant]',requestedVariant))}`; });
      if (banner.hidden) { document.querySelector('main')?.prepend(banner); banner.hidden = false; }
    }
    const value = loadAttribution();
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.querySelectorAll('[data-sleep-quiz-property]').forEach(input => input.remove());
      if (!value || !productPath || value.path !== location.pathname || String(new FormData(form).get('id')) !== value.variant) return;
      Object.entries({ _sleep_quiz_version: version, _sleep_quiz_rank: String(value.rank) }).forEach(([name, text]) => {
        const input = document.createElement('input'); input.type='hidden'; input.name=`properties[${name}]`; input.value=text; input.dataset.sleepQuizProperty=''; form.append(input);
      });
    });
    if (value && productPath && value.path === location.pathname && !viewed) { viewed = true; track('sleep_quiz_product_viewed', {variant_id: value.variant, recommendation_rank: value.rank}); }
  };
  document.addEventListener('submit', event => { if (event.target.matches('form[action*="/cart/add"]')) attach(); }, true);
  document.addEventListener('change', attach);
  document.addEventListener('on:variant:change', attach);
  document.addEventListener('visitorConsentCollected', attach);
  const cartAdded = event => {
    if (!allowed()) return;
    const item = event.detail?.cart?.items?.find(item => String(item.variant_id) === String(event.detail.variantId) && item.properties?._sleep_quiz_version === version);
    if (item) track('sleep_quiz_added_to_cart', {variant_id: String(item.variant_id), product_id: String(item.product_id), recommendation_rank: Number(item.properties._sleep_quiz_rank)});
  };
  document.addEventListener('on:cart:add', cartAdded);
  document.addEventListener('on:line-item:change', event => { if (event.detail?.newQuantity > event.detail?.oldQuantity) cartAdded(event); });
  if (window.Shopify?.customerPrivacy) attach();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => {if (!error) attach();});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, {once:true});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sleep-quiz-comfort-engine"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sleep-quiz-comfort')) {
  class SleepQuizComfort extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('[data-form]');
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.catalog = this.querySelector('[data-catalog]');
      this.results = this.querySelector('[data-results]');
      this.copy = JSON.parse(this.querySelector('[data-translations]').textContent);
      this.index = 0;
      this.attempt = 1;
      this.answered = new Set();
      this.catalogComplete = false;
      this.form.addEventListener('submit', event => { event.preventDefault(); this.advance(); });
      this.querySelector('[data-back]').addEventListener('click', () => this.showStep(this.index - 1));
      this.querySelector('[data-adjust]').addEventListener('click', () => this.adjust());
      this.querySelector('[data-download]').addEventListener('click', () => this.download());
      this.querySelector('[data-share]').addEventListener('click', () => this.share());
      this.form.addEventListener('change', event => {
        if (!this.started) { this.started = true; this.track('sleep_quiz_start', { question_count: 6 }); }
        const input = event.target;
        if (input.name === 'priorities' && input.checked) {
          this.form.querySelectorAll('[name="priorities"]').forEach(other => {
            if (other !== input && (input.value === 'none' || other.value === 'none')) other.checked = false;
          });
        }
        this.querySelector('[data-error]').hidden = true;
        this.saveState(false);
      });
      this.addEventListener('click', event => this.trackClick(event));
      this.catalogPromise = this.loadCatalog().catch(() => false);
      const saved = window.history.state?.cmSleepQuiz;
      if (saved?.version === 'comfort_v2' && saved.answers) {
        this.form.querySelectorAll('input').forEach(input => {
          const value = saved.answers[input.name];
          input.checked = Array.isArray(value) ? value.includes(input.value) : value === input.value;
        });
        this.attempt = Number.isInteger(saved.attempt) ? saved.attempt : 1;
        this.started = Boolean(saved.started);
        this.answered = new Set(Array.isArray(saved.answered) ? saved.answered.filter(index => Number.isInteger(index) && index >= 0 && index < 6) : []);
      }
      this.showStep(Number.isInteger(saved?.index) ? saved.index : 0, false);
      if (saved?.version === 'comfort_v2' && saved.completed && this.steps.every(step => step.querySelector('input:checked'))) this.complete(true);
    }
    t(key, values = {}) {
      return Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll(`[${name}]`, replacement), this.copy[key] || key);
    }
    track(event, parameters = {}) {
      window.CMSleepQuizTracking?.track(event, { attempt_number: this.attempt, ...parameters });
    }
    async loadCatalog() {
      this.catalogComplete = false;
      const destination = this.catalog.querySelector('[data-catalog-page]');
      if (!destination) throw new Error('Missing catalog');
      const ids = new Set([...destination.querySelectorAll('[data-product]')].map(card => card.dataset.id));
      let next = destination.dataset.nextUrl;
      const pages = new Set();
      while (next) {
        const url = new URL(next, window.location.origin);
        if (url.origin !== window.location.origin || pages.has(url.href) || pages.size >= 20) throw new Error('Invalid pagination');
        pages.add(url.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(12000) });
        if (!response.ok) throw new Error('Catalog request failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-catalog-page]');
        if (!page) throw new Error('Catalog page missing');
        page.querySelectorAll('[data-product]').forEach(card => {
          if (!ids.has(card.dataset.id)) { ids.add(card.dataset.id); destination.append(card); }
        });
        next = page.dataset.nextUrl;
      }
      this.catalogComplete = true;
      this.catalog.dataset.loadedProducts = String(ids.size);
      return true;
    }
    answers() {
      const data = new FormData(this.form);
      return { size: data.get('size'), position: data.get('position'), weight: data.get('weight'), surface: data.get('surface'), priorities: data.getAll('priorities'), budget: data.get('budget') };
    }
    saveState(completed) {
      try { window.history.replaceState({ ...window.history.state, cmSleepQuiz: { version: 'comfort_v2', answers: this.answers(), index: this.index, attempt: this.attempt, started: Boolean(this.started), answered: [...this.answered], completed } }, ''); } catch (error) {}
    }
    showStep(index, focus = true) {
      this.index = Math.max(0, Math.min(5, index));
      this.steps.forEach((step, i) => { step.hidden = i !== this.index; });
      this.querySelector('[data-progress]').value = this.index + 1;
      this.querySelector('[data-progress-label]').textContent = this.t('progress', { number: this.index + 1 });
      this.querySelector('[data-back]').hidden = this.index === 0;
      this.querySelector('[data-next]').textContent = this.t(this.index === 5 ? 'see' : 'next');
      this.querySelector('[data-budget-hint]').textContent = this.t('budget_hint', { size: this.t(`size_${this.answers().size || 'queen'}`), currency: this.dataset.currency });
      this.querySelector('[data-error]').hidden = true;
      if (focus) this.steps[this.index].querySelector('legend').focus({ preventScroll: true });
      this.saveState(false);
    }
    advance() {
      if (this.busy) return;
      if (!this.steps[this.index].querySelector('input:checked')) {
        this.showError('error');
        this.steps[this.index].querySelector('input').focus({ preventScroll: true });
        return;
      }
      if (!this.answered.has(this.index)) {
        this.answered.add(this.index);
        this.track('sleep_quiz_question_answered', { question_number: this.index + 1, question_id: this.steps[this.index].dataset.step, question_count: 6 });
      }
      if (this.index < 5) this.showStep(this.index + 1);
      else this.complete();
    }
    showError(key) { const error = this.querySelector('[data-error]'); error.textContent = this.t(key); error.hidden = false; }
    async complete(restoring = false) {
      this.busy = true;
      const button = this.querySelector('[data-next]');
      button.disabled = true;
      button.textContent = this.t('loading');
      try {
        await this.catalogPromise;
        if (!this.catalogComplete) this.catalogPromise = this.loadCatalog();
        await this.catalogPromise;
        if (!this.catalogComplete) throw new Error('Incomplete catalog');
        this.latestAnswers = this.answers();
        this.profile = this.buildProfile(this.latestAnswers);
        this.matches = this.rank(this.latestAnswers, this.profile);
        this.render();
        this.form.hidden = true;
        this.querySelector('[data-intro]').hidden = true;
        this.results.hidden = false;
        this.saveState(true);
        this.querySelector('[data-results-heading]').focus({ preventScroll: true });
        this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (!restoring) this.track('sleep_quiz_completed', { question_count: 6, recommendation_count: this.matches.length });
      } catch (error) {
        this.catalogPromise = Promise.resolve(false);
        this.showError('load_error');
        this.track('sleep_quiz_catalog_error');
      } finally { this.busy = false; button.disabled = false; button.textContent = this.t('see'); }
    }
    buildProfile(answers) {
      let firmness = { side: 4.5, back: 6.5, stomach: 8, combination: 6 }[answers.position] || 6;
      if (answers.weight === 'light') firmness -= 1;
      if (answers.weight === 'heavy') firmness += 1.5;
      firmness = Math.max(1, Math.min(10, firmness));
      const classification = firmness < 3 ? 'soft' : firmness < 5 ? 'medium_soft' : firmness < 6.5 ? 'medium' : firmness < 8 ? 'medium_firm' : 'firm';
      return { firmness, classification };
    }
    metric(value) {
      if (value == null || String(value).trim() === '') return null;
      const number = Number(value);
      return Number.isFinite(number) && number >= 1 && number <= 10 ? number : null;
    }
    normalizeSize(value) {
      const key = String(value).toLowerCase().replace(/["'″’]/g, '').replace(/\s+/g, '').replace(/×/g, 'x');
      const sizes = { twin: ['twin','single','38x75','39x75'], twinxl: ['twinxl','extr longtwin','extralongtwin','xl twin','xltwin','38x80','39x80'], double: ['double','full','double/full','full/double','54x75'], queen: ['queen','60x80'], king: ['king','76x80'], californiaking: ['californiaking','califorinaking','calking','72x84','californiaking(72x84)','califorinaking(72x84)'] };
      return Object.keys(sizes).find(size => sizes[size].includes(key)) || null;
    }
    score(card, answers, profile) {
      const metrics = Object.fromEntries(['firmness','pressure','cooling','motion'].map(key => [key, this.metric(card.dataset[key])]));
      if (metrics.firmness === null || Math.abs(metrics.firmness - profile.firmness) > 2) return null;
      const pressureWeight = answers.priorities.includes('pressure') || answers.position === 'side' ? 2 : 0.5;
      const weights = { pressure: pressureWeight, cooling: answers.priorities.includes('cooling') ? 2 : 0, motion: answers.priorities.includes('motion') ? 2 : 0 };
      let score = 50 - 12 * Math.abs(metrics.firmness - profile.firmness);
      for (const key of Object.keys(weights)) score += (metrics[key] ?? 0) * weights[key];
      const surface = ['responsive','contouring','balanced'].includes(card.dataset.surface) ? card.dataset.surface : null;
      if (answers.surface !== 'unsure') {
        if (surface === answers.surface) score += 12;
        else if (surface === 'balanced' || (answers.surface === 'balanced' && surface)) score += 6;
      }
      return { card, score, metrics, surface };
    }
    rank(answers, profile) {
      const cap = { under1000: 100000, under2000: 200000, under3500: 350000, flexible: Infinity }[answers.budget] ?? Infinity;
      const ids = new Set();
      const ranked = [...this.catalog.querySelectorAll('[data-product]')].flatMap(card => {
        if (ids.has(card.dataset.id)) return [];
        ids.add(card.dataset.id);
        const variants = JSON.parse(card.querySelector('[data-variants]').textContent);
        const variant = variants.filter(item => item.available && item.price >= 0 && item.options.some(option => this.normalizeSize(option) === answers.size)).sort((a,b) => a.price - b.price)[0];
        if (!variant || variant.price >= cap) return [];
        const match = this.score(card, answers, profile);
        return match ? [{ ...match, variant }] : [];
      }).sort((a,b) => b.score - a.score || a.variant.price - b.variant.price || a.card.dataset.id.localeCompare(b.card.dataset.id));
      if (!ranked.length) return [];
      const first = ranked[0];
      const alternative = ranked.slice(1).find(match => match.variant.price < first.variant.price && match.score >= first.score - 15);
      const second = alternative || ranked.slice(1).find(match => match.score >= first.score - 15);
      return second ? [first, second] : [first];
    }
    money(cents) { return new Intl.NumberFormat(this.dataset.locale || 'en-CA', { style: 'currency', currency: this.dataset.currency || 'CAD' }).format(cents / 100); }
    reasons(match) {
      const answers = this.latestAnswers;
      const result = [this.t('firmness_reason', { score: match.metrics.firmness, target: this.profile.firmness })];
      for (const key of ['pressure','cooling','motion']) {
        if ((answers.priorities.includes(key) || (key === 'pressure' && answers.position === 'side')) && match.metrics[key] !== null) result.push(this.t(`${key}_reason`, { score: match.metrics[key] }));
      }
      if (match.surface) result.push(this.t('surface_reason', { surface: this.t(`feel_${match.surface}`) }));
      return result;
    }
    tradeoff(match, first) {
      if (match.variant.price >= first.variant.price) return '';
      const differences = ['cooling','pressure','motion'].filter(key => (this.latestAnswers.priorities.includes(key) || (key === 'pressure' && this.latestAnswers.position === 'side')) && match.metrics[key] !== null && first.metrics[key] !== null && match.metrics[key] < first.metrics[key]).map(key => this.t(`less_${key}`));
      if (Math.abs(match.metrics.firmness - this.profile.firmness) > Math.abs(first.metrics.firmness - this.profile.firmness)) differences.push(this.t('different_firmness'));
      if (this.latestAnswers.surface !== 'unsure' && match.surface !== first.surface) differences.push(this.t('different_surface'));
      if (!match.surface || ['pressure','cooling','motion'].some(key => this.latestAnswers.priorities.includes(key) && match.metrics[key] === null)) differences.push(this.t('unknown_ratings'));
      return this.t(differences.length ? 'saving' : 'similar', { amount: this.money(first.variant.price - match.variant.price), tradeoff: differences.join(', ') });
    }
    productURL(match, tracked = true) {
      const url = new URL(match.card.querySelector('[data-product-link]').getAttribute('href'), window.location.origin);
      url.searchParams.set('variant', match.variant.id);
      if (tracked) { url.searchParams.set('sq', 'comfort_v2'); url.searchParams.set('sq_rank', this.matches.indexOf(match) + 1); }
      return url.href;
    }
    render() {
      const answers = this.latestAnswers;
      const size = this.t(`size_${answers.size}`);
      const priorities = answers.priorities.filter(key => key !== 'none').map(key => this.t(`priority_${key}`));
      const profile = this.t('profile', { firmness: this.t(`firmness_${this.profile.classification}`), score: this.profile.firmness, surface: this.t(`feel_${answers.surface}`) });
      this.querySelector('[data-profile]').textContent = profile + (priorities.length ? ' ' + this.t('profile_priorities', { priorities: priorities.join(', ') }) : '');
      this.querySelector('[data-result-context]').textContent = this.t('context', { size, budget: this.t(`budget_${answers.budget}`), currency: this.dataset.currency });
      this.querySelector('[data-surface-note]').textContent = this.t(this.matches.some(match => !match.surface) ? 'unknown_surface' : 'known_surface');
      const destination = this.querySelector('[data-matches]');
      destination.replaceChildren();
      this.matches.forEach((match, index) => {
        const card = match.card.cloneNode(true);
        card.querySelector('[data-variants]').remove();
        card.dataset.rank = index + 1;
        card.dataset.variantId = match.variant.id;
        card.querySelector('[data-match-label]').textContent = this.t(index === 0 ? 'best' : match.variant.price < this.matches[0].variant.price ? 'alternative' : 'another');
        card.querySelector('[data-price]').textContent = `${size} · ${match.variant.priceText}`;
        card.querySelectorAll('[data-product-link]').forEach(link => { link.href = this.productURL(match); });
        card.querySelector('[data-view]').textContent = this.t('view_size', { size });
        const list = card.querySelector('[data-reasons]');
        this.reasons(match).forEach(reason => { const li = document.createElement('li'); li.textContent = reason; list.append(li); });
        const tradeoff = index ? this.tradeoff(match, this.matches[0]) : '';
        card.querySelector('[data-tradeoff]').textContent = tradeoff;
        card.querySelector('[data-tradeoff]').hidden = !tradeoff;
        const tryLink = card.querySelector('[data-try]');
        if (tryLink) {
          tryLink.setAttribute('aria-label', this.t('try_product', { product: card.querySelector('h3').textContent }));
          const url = new URL(tryLink.href);
          url.searchParams.set('sleep_match_product', card.querySelector('h3').textContent.trim());
          url.searchParams.set('sleep_match_variant', match.variant.id);
          tryLink.href = url.href;
        }
        destination.append(card);
      });
      this.querySelector('[data-no-matches]').hidden = this.matches.length > 0;
    }
    trackClick(event) {
      const link = event.target.closest('a');
      if (!link || !this.contains(link)) return;
      const card = link.closest('[data-matches] [data-product]');
      if (link.hasAttribute('data-showroom') || link.hasAttribute('data-try')) {
        this.track('sleep_quiz_showroom_cta_clicked', { showroom_location: link.dataset.showroom || 'ask_availability', product_id: card?.dataset.id || '' });
      } else if (card && link.hasAttribute('data-product-link')) {
        this.track('sleep_quiz_recommendation_clicked', { product_id: card.dataset.id, variant_id: card.dataset.variantId, recommendation_rank: Number(card.dataset.rank) });
      }
    }
    adjust() {
      this.attempt += 1;
      this.answered.clear();
      this.track('sleep_quiz_retaken');
      this.results.hidden = true;
      this.form.hidden = false;
      this.querySelector('[data-intro]').hidden = false;
      this.querySelector('[data-status]').hidden = true;
      this.showStep(0);
      this.form.scrollIntoView({ block: 'start' });
    }
    summaryLines() {
      return [this.t('download_title'), this.querySelector('[data-profile]').textContent, this.querySelector('[data-result-context]').textContent, '', ...this.matches.flatMap((match,index) => [this.t(index === 0 ? 'best' : match.variant.price < this.matches[0].variant.price ? 'alternative' : 'another'), match.card.querySelector('h3').textContent.trim(), `${this.t(`size_${this.latestAnswers.size}`)}: ${match.variant.priceText}`, ...this.reasons(match), ...(index ? [this.tradeoff(match,this.matches[0])] : []), this.productURL(match, false), '']), this.querySelector('[data-offer]')?.textContent || '', this.querySelector('[data-offer-detail]')?.textContent || '', this.querySelector('.sq__disclaimer')?.textContent || ''];
    }
    download() {
      if (!this.matches) return;
      const ascii = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[–—·]/g,'-').replace(/[‘’]/g,"'").replace(/[“”]/g,'"').replace(/[^\x20-\x7E]/g,' ');
      const lines = this.summaryLines().flatMap(value => ascii(value).match(/.{1,86}(?:\s|$)|.{1,86}/g) || ['']);
      const chunks = [];
      while (lines.length) chunks.push(lines.splice(0,43));
      const objects = ['<< /Type /Catalog /Pages 2 0 R >>', '', '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>'];
      const pageIDs = [];
      chunks.forEach(chunk => {
        const id = objects.length + 1;
        pageIDs.push(`${id} 0 R`);
        const escaped = chunk.map(line => line.replace(/\\/g,'\\\\').replace(/\(/g,'\\(').replace(/\)/g,'\\)'));
        const stream = `BT /F1 11 Tf 48 745 Td 16 TL ${escaped.map((line,i) => `${i ? 'T* ' : ''}(${line}) Tj`).join('\n')} ET`;
        objects.push(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources << /Font << /F1 3 0 R >> >> /Contents ${id+1} 0 R >>`, `<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`);
      });
      objects[1] = `<< /Type /Pages /Kids [${pageIDs.join(' ')}] /Count ${pageIDs.length} >>`;
      let pdf = '%PDF-1.4\n';
      const offsets = [0];
      objects.forEach((object,i) => { offsets.push(pdf.length); pdf += `${i+1} 0 obj\n${object}\nendobj\n`; });
      const xref = pdf.length;
      pdf += `xref\n0 ${objects.length+1}\n0000000000 65535 f \n${offsets.slice(1).map(offset => String(offset).padStart(10,'0')+' 00000 n \n').join('')}trailer\n<< /Size ${objects.length+1} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF`;
      const url = URL.createObjectURL(new Blob([pdf], {type:'application/pdf'}));
      const link = document.createElement('a'); link.href = url; link.download = 'Canadian-Mattress-Sleep-Match.pdf'; document.body.append(link); link.click(); link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 30000);
      this.track('sleep_quiz_pdf_downloaded');
    }
    async share() {
      const text = this.summaryLines().join('\n');
      try {
        if (navigator.share) await navigator.share({ title: this.t('share_title'), text });
        else { await navigator.clipboard.writeText(text); this.status('copied'); }
        this.track('sleep_quiz_results_shared');
      } catch (error) { if (error.name !== 'AbortError') this.status('share_failed'); }
    }
    status(key) { const status = this.querySelector('[data-status]'); status.hidden = false; status.textContent = this.t(key); }
  }
  customElements.define('sleep-quiz-comfort', SleepQuizComfort);
}
  } catch(e) { console.error(e); }
})();

})();
